/**
 * Development Tools
 *
 * Development mode check. The mock-data generators and query-cache/state
 * debugging helpers that used to live here were removed in DEV2-1271 — they
 * were never invoked by any component, hook, or console tooling.
 */

import { isDevelopment } from './featureFlags';

// Development mode check
export const isDev = isDevelopment();
